import React, { Component } from 'react'
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import arrow_right_img from '../../utils/assets/images/arrow-right.png'
import SouscriptionSwitcher from '../../components/SouscriptionSwitcher'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import {  fetchSouscripteurAction, fetchUpdateSouscripteurAction, fetchSendMailSouscripteurAction } from '../../actions/Souscription/Souscripteur'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class DataProtection extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
    isChecked: false,
    applyRedirectNext: false,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Protection des données`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, reauthenticateMembers, reauthenticateCourtiers, getReauthenticateCourtiers, userGetSouscripteur } = this.props

    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }

      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }else {
        getReauthenticateCourtiers()
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur } = nextProps
    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
  }
  handleDataProtectionNext = event => {
    event.preventDefault()
    const { isChecked } = this.state

    if (isChecked) {
      this.setState({ applyRedirectNext: true })
    }
  }
  handleCheckBox = (event) => {
    this.setState({isChecked: event.target.checked})
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur } = this.props
    const {applyRedirectNext, isCurrentLoginCourtier} = this.state
    return(
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(getSouscripteur.souscripteurData.status === "submitted" || getSouscripteur.souscripteurData.status === "payment-pending") && <Redirect to="/soumis" push/>}
          {(getSouscripteur.souscripteurData.status === "police-active") && <Redirect to="/soumis" push/>}
          {applyRedirectNext &&
            <div>
              <Redirect to='/declaration' push/>
            </div>
          }
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-menu-tab-content">
                  <SouscriptionSwitcher match={match} />
                  <div>
                    <div className="uk-text-center aps-dashboard-souscripteur-title uk-text-bold" style={{paddingBottom: "50px"}}>
                      Protection des données
                    </div>
                    <div className="aps-section-alerte-green-container-declaration">
                      <div className="aps-section-alerte-green-container-simulation-check" data-uk-grid>
                        <div className="uk-width-1-6 aps-section-alerte-green-arrow-right">
                          <img src={arrow_right_img} alt="arrow-right" />
                        </div>
                        <div className="uk-width-expand aps-section-alerte-green-expand">
                          <div className="aps-section-questionnaire-clause-data-title uk-text-center uk-text-bold">
                            Législation sur la protection des données – collecte et utilisation d’informations à caractère personnel  
                          </div>
                          <p className="aps-section-alerte-green-content-full uk-text-bold uk-text-justify">
                            Toute référence aux informations inclut les données et informations à caractère personnel que vous nous avez transmises, que ce soit dans le bulletin d’adhésion,
                            tout formulaire de demande de remboursement, tout formulaire d’entente préalable et/ou tout autre document complémentaire ou information que nous
                            pourrions recueillir en lien avec un produit ou service que nous proposons. Atlantique Assurances Bénin et le courtier mandataire de l’APS-Bénin, sont les
                            responsables de la protection de ces données. <br /> <br />

                            <span class="uk-text-bold">Utilisation</span> : Les informations personnelles peuvent être utilisées dans le but de gérer l’assurance (y compris la souscription, le traitement des demandes de
                            remboursement et la prévention des fraudes). Nous pouvons avoir recours à des organismes tiers pour traiter des données en notre nom. Ce traitement, qui
                            peut avoir lieu en dehors du Bénin, est soumis à des restrictions contractuelles en ce qui concerne la confidentialité et la sécurité, en accord avec les
                            exigences en matière de protection des données. <br /> <br />

                            <span class="uk-text-bold">Données sensibles</span> : Nous devons recueillir des données sensibles vous concernant (telles que des informations médicales), afin d’évaluer les termes de
                            l’assurance que nous émettons/fixons et/ou pour gérer les demandes de remboursement. <br /> <br />

                            <span class="uk-text-bold">Communication</span> : Nous pouvons transmettre les informations vous concernant à nos agents, aux membres de la commission médicale SƆHU de l’assureur, à
                            d’autres assureurs et leurs agents, aux prestataires de service, à tout intermédiaire vous représentant ou aux autorités de contrôle/gouvernementales (dont
                            nous faisons partie ou qui nous gouvernent). Nous pouvons, dans certains cas, faire appel à des enquêteurs privés pour obtenir plus d’informations sur l’une
                            de vos demandes de remboursement.  <br /> <br />

                            <span class="uk-text-bold">Conservation</span> : Nous sommes tenus de conserver vos données pendant les six années suivant la fin de la période d’assurance. Nous ne conserverons pas vos
                            données plus longtemps que nécessaire et uniquement pour les finalités pour lesquelles nous les avons obtenues. <br /> <br />

                            <span class="uk-text-bold">Représentation et consentement</span> : Par votre signature, vous confirmez que vous avez l’autorité pour agir au nom de vos ayants droit en ce qui concerne toutes
                            les informations à caractère personnel que vous nous fournissez, et que vous consentez au traitement, à la divulgation, à l’utilisation et à la conservation des
                            informations vous concernant et/ou à propos de vos ayants droit. <br /> <br />

                            <span class="uk-text-bold">Accès</span> : Vous avez le droit de demander à recevoir une copie des données à caractère personnel vous concernant en notre possession. Si vous souhaitez exercer
                            ce droit, veuillez écrire au responsable de la protection des données à l’adresse indiquée sur ce formulaire ou à contact@aps-benin.com.  <br /> <br />

                            <span class="uk-text-bold">Enregistrement des appels</span> :  Les appels téléphoniques sont enregistrés et peuvent être écoutés dans le cadre de la formation du personnel, afin d’améliorer la
                            qualité de nos services et pour des raisons réglementaires.  <br /> <br />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="aps-dashboard-souscription-switch">
                      <div className="aps-dashboard-declaration-termes uk-text-center" data-uk-grid>
                        <p className="uk-width-expand">
                          <input
                            styles="padding-right: 14px;"
                            className="uk-checkbox aps-questionnaire-answers-checkbox"
                            type="checkbox"
                            onChange={event => this.handleCheckBox(event)}
                          />{" "}
                          En cochant, je comprends et accepte les déclarations ci-dessus.
                        </p>
                      </div>

                      <div className="aps-dashboard-souscription-switch-btn aps-dashboard-souscription-switch-btn-declaration aps-bottom-btn-text-position-second">
                        <Link
                          to="/questionnaire"
                          className="uk-button aps-btn-silver"
                        >
                          Section précédente
                        </Link>

                        <button
                          className={`uk-button aps-btn-green aps-btn-green-dashboard-btn  ${!this.state.isChecked ? 'aps-section-register-action-btn-no-active apply-disabled-btn' : ''}`}
                          onClick={(event) => this.handleDataProtectionNext(event)}
                          disabled={!this.state.isChecked}
                        >Section suivante</button>
                      </div>

                    </div>
                  </div>
                </div>
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
              </Dashboard>
          }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, updateSouscripteur, getSouscripteur }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    updateSouscripteur,
    getSouscripteur
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
    userUpdateSouscripteur: (souscripteurID, souscripteurData) => dispatch(fetchUpdateSouscripteurAction(souscripteurID, souscripteurData)),
    userSendMailSouscripteur: (emailData) => dispatch(fetchSendMailSouscripteurAction(emailData)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DataProtection)



// WEBPACK FOOTER //
// ./src/containers/DataProtection/index.js